import { Badge, formatTimeDate } from "@";
import { actionOptions, activityOptions } from "../utils/options";

// TanStack table columns configuration
export const tableColumns = [
  {
    id: "createdOn",
    header: "التاريخ",
    accessorFn: ({ createdOn }) => formatTimeDate(createdOn),
  },
  {
    id: "displayName",
    header: "المستخدم",
    accessorFn: ({ displayName }) => displayName,
  },
  {
    id: "action",
    header: "الحدث",
    cell: ({ row }) => (
      <Badge
        title={actionOptions?.[row.original.action]?.name}
        color={actionOptions?.[row.original.action]?.color}
      />
    ),
  },
  {
    id: "activity",
    header: "النشاط",
    cell: ({ row }) => (
      <Badge
        title={activityOptions?.[row.original.activity]?.name}
        color={activityOptions?.[row.original.activity]?.color}
      />
    ),
  },
  {
    id: "description",
    header: "الوصف",
    size: 300,
    accessorFn: ({ description }) => description,
  },
];
